import React, { useState, useEffect } from 'react'
import * as R from 'ramda'
import { v4 } from 'uuid'
import { Link } from 'gatsby'
import { getCorrectPropertyObject } from '../utils'
import Image from './Image'

const SimilarProperties = ({ title, price, properties, locale, propertyObject }) => {

  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return null;
  }
  // drop same property
  const updatedPropertyArray = R.reject((item) => item.node.frontmatter.title === title, properties);
  // sort by price
  const propertiesSortedByPrice =  updatedPropertyArray.sort((a, b) => (
    parseFloat(b.node.frontmatter.startingPrice.replace(/,/g, '')) - parseFloat(a.node.frontmatter.startingPrice.replace(/,/g, ''))
  ));
  // split into price chunks
  const chunkedProperties = R.splitEvery(4, propertiesSortedByPrice);
  // drop irregular array
  const droppedIrregularArray = R.reject((chunk) => chunk.length !== 4, chunkedProperties);
  const findSimilarProperties = R.find((item) =>(
    parseFloat(item[0].node.frontmatter.startingPrice.replace(/,/g, '')) <= parseFloat(price.replace(/,/g, ''))
  ))(droppedIrregularArray);
  const similarProperties = !!findSimilarProperties ? findSimilarProperties : droppedIrregularArray[droppedIrregularArray.length - 1]

  
  const mappedProperties = similarProperties.map((property) => {
    const titleIfAvailable = getCorrectPropertyObject(property.node.frontmatter, propertyObject).title;
    const propertyTitle = !!titleIfAvailable ? titleIfAvailable : property.node.frontmatter.title;

    return (
    <div className="hover-zoom column is-6 similar-property" key={v4()}>
      <Link to={`${locale}${property.node.fields.slug}`}>
        <Image imageInfo={{ image: property.node.frontmatter.featuredImage }} classes="similar-properties-image" />
        <div className="similar-property-overlay">
          <div className="similar-property-overlay-text">
            <h4 className="title similar-property-title">{ propertyTitle}</h4>
            <div className="similar-property-text">{getCorrectPropertyObject(property.node.frontmatter, propertyObject).short_description}</div>
          </div>
        </div>
      </Link>
    </div>
    )
  });  
  return (
    <div className="columns similar-property-container is-multiline is-gapless">
      { mappedProperties }
    </div>
  );
}

export default SimilarProperties;